import * as z from 'zod';

import { percentageInput } from '@/_schemas/generic';

import { categoryQuerySchema } from './category-query-schema';

export const categoryUpdateSchema = categoryQuerySchema
  .omit({
    description: true,
    sku_prefix: true,
    wholesale_discount: true,
    status: true,
    children: true,
    parent: true,
    products_count: true,
  })
  .extend({
    description: z.string(),
    sku_prefix: z.string(),
    wholesale_discount: percentageInput.mutationSchema(),
    status: z.string(),
  });

export type CategoryUpdateSchema = z.infer<typeof categoryUpdateSchema>;

export const categoryCreateSchema = categoryUpdateSchema.omit({
  id: true,
});

export type CategoryCreateSchema = z.infer<typeof categoryCreateSchema>;
